import { Component, OnDestroy, OnInit } from '@angular/core';
import { HuntApiService, Overview } from '../hunt-api.service';
import { accessMessage } from '../hunt-errors';

@Component({
  selector: 'app-hunt-dashboard',
  templateUrl: './hunt-dashboard.component.html',
  styleUrls: ['./hunt-dashboard.component.scss'],
})
export class HuntDashboardComponent implements OnInit, OnDestroy {
  o: Overview | null = null;
  error = '';
  notice = '';
  busy = false;
  now = Date.now();
  private timers: any[] = [];

  constructor(private api: HuntApiService) {}

  ngOnInit() {
    this.load();
    this.timers.push(setInterval(() => this.load(true), 30000)); // keep it live
    this.timers.push(setInterval(() => (this.now = Date.now()), 1000)); // countdowns
  }
  ngOnDestroy() { this.timers.forEach(clearInterval); }

  load(quiet = false) {
    if (!quiet) this.error = '';
    this.api.overview().subscribe(
      (o) => { this.o = o; this.error = ''; },
      (e) => (this.error = accessMessage(e)),
    );
  }

  setState(action: 'start' | 'pause' | 'resume' | 'stop') {
    const ask = {
      start: 'Start the hunt? Scheduled bones go live at their times.',
      pause: 'Pause the hunt? Players see "paused" and opening rooms finds nothing until you resume.',
      resume: 'Resume the hunt? The live bone gets its remaining time back and later bones move by the paused time.',
      stop: 'Stop the hunt? Players no longer see it. Bones and finds are kept.',
    }[action];
    if (!confirm(ask)) return;
    this.busy = true;
    this.notice = '';
    this.api.setState(action).subscribe(
      (s) => {
        this.busy = false;
        this.notice = `Hunt ${s.status}.${s.shiftedBones ? ` ${s.shiftedBones} bones moved later by the paused time.` : ''}`;
        this.load();
      },
      (e) => { this.busy = false; this.error = accessMessage(e); },
    );
  }

  left(until: number | null) { return until ? Math.max(0, until - this.now) : null; }
  releasedClues() {
    const b = this.o && this.o.live;
    if (!b || !b.opensAt) return [];
    return b.clues.map((c) => ({ ...c, released: b.opensAt + c.after * 60000 <= this.now }));
  }
}
